import React from "react";
import { useRatedManagers } from "../../hooks/useRatedManagers";
import RatedManagerCard from "./RatedManagerCard";
import LoadingSpinner from "./LoadingSpinner";
import "./RatedManagersSection.css";

const RatedManagersSection = () => {
  const { ratedManagers, isLoading, error, hasMore, loadMore, refresh } =
    useRatedManagers();

  if (error) {
    return (
      <div className="rated-managers-section">
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button onClick={refresh} className="retry-btn">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="rated-managers-section">
      <div className="section-header">
        <h3>Your Rating History</h3>
        {ratedManagers.length > 0 && (
          <button onClick={refresh} className="refresh-btn">
            <i className="bi bi-arrow-clockwise"></i>
            Refresh
          </button>
        )}
      </div>

      {isLoading && ratedManagers.length === 0 ? (
        <div className="loading-container">
          <LoadingSpinner size="medium" text="Loading your ratings..." />
        </div>
      ) : ratedManagers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">
            <i className="bi bi-star"></i>
          </div>
          <h4>No ratings yet</h4>
          <p>
            You haven't rated any managers yet. Start by reviewing a manager!
          </p>
        </div>
      ) : (
        <>
          <div className="ratings-grid">
            {ratedManagers.map((manager) => (
              <RatedManagerCard key={manager.review_id} manager={manager} />
            ))}
          </div>

          {hasMore && (
            <div className="load-more-container">
              <button
                onClick={loadMore}
                className="load-more-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="loading-spinner-inline"></span>
                    Loading...
                  </>
                ) : (
                  "View More"
                )}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RatedManagersSection;
